import { Component, Suspense, type ReactNode } from "react";
import { useI18n } from "../lib/i18n";

class LoadBoundary extends Component<{ children: ReactNode; message: string; reload: string }, { failed: boolean }> {
  state = { failed: false };
  static getDerivedStateFromError() {
    return { failed: true };
  }
  render() {
    if (this.state.failed) {
      return (
        <div className="glass-card report-block" role="alert">
          <p>{this.props.message}</p>
          <button onClick={() => window.location.reload()}>{this.props.reload}</button>
        </div>
      );
    }
    return this.props.children;
  }
}

/**
 * Most screens are loaded on demand, so any of them can fail to arrive on a
 * phone that has just lost signal. This keeps that failure inside the panel:
 * the navigation stays usable and the family can move to a screen they already
 * have. Remounting on a page change clears it.
 */
export function LazyPanel({ children }: { children: ReactNode }) {
  const { t } = useI18n();
  return (
    <LoadBoundary message={t("panel.failed")} reload={t("panel.reload")}>
      <Suspense fallback={<p role="status" className="glass-card report-block">{t("resources.loading")}</p>}>{children}</Suspense>
    </LoadBoundary>
  );
}
